export default class FancyFilters {
  constructor() {
    this.calendar = null;
    this.current_duration = '';
    this.current_duration_start = '';
    this.current_duration_start_obj = '';
    this.current_duration_end = '';
    this.current_duration_end_obj = '';
    this.duration_filters = document.querySelectorAll('.js-filter-durations .js-listing-filter');
    this.current_categories = [];
    this.num_categories = document.querySelectorAll('.js-listing-filter[data-filter-type="event-category"]').length;
    this.monthPicker = document.querySelector('.js-month-picker');
    this.monthSelect = document.querySelector('.js-month-select');
    this.selectedMonth = '';
    this.customDateLabel = document.querySelector('.js-custom-date-label');
    this.customDateLabelMobile = document.querySelector('.--mobile .js-custom-date-label');
    this.category_button = document.querySelector('.js-category-button');
    this.category_filters = document.querySelectorAll('.js-filter-categories .js-listing-filter');
    this.message_bar = document.querySelector('.js-message-bar');
    this.temp_bar = document.querySelector('.js-temp-bar');
    this.show_num_categories = 20;
    this.show_num_categories_mobile = 4;
    this.event_bus = window.event_bus;

    //minimize categories on load if there are more than we should show
    if(this.num_categories > this.show_num_categories) {
      this.toggleAllCategories();
      // we have decided to display all categories and hide the button by default for now

      // this.category_button.addEventListener('click', (event) => {
      //   this.toggleAllCategories();
      // });
    } else {
      //hide the category button if we don't need it
      //this.category_button.style.display = "none";
    }

    if (this.monthPicker) {
      this.monthButtons = this.monthPicker.querySelectorAll('button');
      
      this.monthButtons.forEach((button) => {
        button.addEventListener('click', (event) => this.handleMonthClick(event));
      });
    }

    if (this.monthSelect) {
      this.monthSelect.addEventListener('change', (event) => this.handleMonthChange(event));
    }
  }

  handleMonthClick(event) {
    const button = event.currentTarget;
    const monthNumber = button.dataset.month;
    this.selectedMonth = button.textContent;
  
    if (monthNumber) {
      const year = new Date().getFullYear();
      this.current_duration_start = `${year}-${monthNumber}-01`;
      this.current_duration_end = `${year}-${monthNumber}-${new Date(year, monthNumber, 0).getDate()}`;
    }
  
    this.monthButtons.forEach(btn => btn.classList.remove('--active'));
    button.classList.add('--active');
  
    if (this.customDateLabel) {
      this.customDateLabel.textContent = `${this.selectedMonth}`;
    }
  }

  handleMonthChange(event) {
    const select = event.target;
    const monthNumber = select.value;
    const monthName = select.options[select.selectedIndex].text;
    this.selectedMonth = monthName;

    if (monthNumber) {
      const year = new Date().getFullYear();
      this.current_duration_start = `${year}-${monthNumber}-01`;
      this.current_duration_end = `${year}-${monthNumber}-${new Date(year, monthNumber, 0).getDate()}`;
    }

    if (this.customDateLabelMobile) {
      this.customDateLabelMobile.textContent = `${this.selectedMonth}`;
    }
  }

  getFormattedCustomDate() {
    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    if(this.current_duration_start_obj.getMonth() == this.current_duration_end_obj.getMonth()) {
      if(this.current_duration_start_obj.getDate() == this.current_duration_end_obj.getDate()) {
        //June 15
        return months[this.current_duration_start_obj.getMonth()] + " " + this.current_duration_start_obj.getDate();
      } else {
        //June 15 - 18
        return months[this.current_duration_start_obj.getMonth()] + " " + this.current_duration_start_obj.getDate() + " - " + this.current_duration_end_obj.getDate();
      }
    } else {
      //June 15 - May 20
      return months[this.current_duration_start_obj.getMonth()] + " " + this.current_duration_start_obj.getDate() + " - " + months[this.current_duration_end_obj.getMonth()] + " " + this.current_duration_end_obj.getDate();
    }
  }

  toggleAllCategories() {
    if(this.category_button.dataset.showingAll == 'true') {
      //hide extra categories
      var filter_count = 0;
      this.category_filters.forEach((filter) => {
        filter_count++;
        if(document.body.scrollWidth <= 500) {
          //use mobile size
          if(filter_count > this.show_num_categories_mobile) {
            filter.classList.add('--hidden');
          }
        } else {
          //use desktop size
          if(filter_count > this.show_num_categories) {
            filter.classList.add('--hidden');
          }
        }
      });
      this.category_button.dataset.showingAll = 'false';
      this.category_button.innerHTML = 'Show more Categories +';
    } else {
      this.category_filters.forEach((filter) => {
        filter.classList.remove('--hidden');
      });
      this.category_button.dataset.showingAll = 'true';
      this.category_button.innerHTML = 'Show fewer Categories -';
    }
  }

  categoryChanged(filter) {
    if(filter.querySelector('input[type="checkbox"]').checked == true) {
      this.remove(filter.dataset.filterValue);
      filter.classList.remove('--active');
      filter.querySelector('input[type="checkbox"]').checked = false;
    } else {
      this.add(filter.dataset.filterValue);
      filter.classList.add('--active');
      filter.querySelector('input[type="checkbox"]').checked = true;
    }
  }

  add(num) {
    if(!this.current_categories.includes(num)) {
      this.current_categories.push(num);
    }
  }

  remove(num) {
    var index = 0;
    this.current_categories.forEach((current_category) => {
      if(current_category == num) {
        this.current_categories.splice(index, 1);
      }
      index++;
    });
  }

  durationChanged(filter) {
    var deselect = false;
    if(filter.classList.contains('--active')) {
      //we should delect
      deselect = true;
    }

    this.duration_filters.forEach((duration_filter) => {
      duration_filter.classList.remove('--active');
    });

    if(deselect) {
      this.current_duration = "";

      if(filter.classList.contains('js-custom-date')) {
        filter.querySelector('.js-custom-date-label').innerHTML = 'When are you visiting?';
      }
    } else {
      this.current_duration = filter.dataset.filterValue;
      filter.classList.add('--active');
    }
  }

  unpackCategories(category_string) {
    this.current_categories = category_string.split(' ');
  }

  packCategories() {
    return this.current_categories.join(' ');
  }

  updateTempStatusBar(filter_value) {
    // we are disabling for now
    return
    var sub_string = '';
    if(filter_value == 'this-weekend') {
      sub_string = 'for this weekend';
    } else if(filter_value == 'next-7-days') {
      sub_string = 'for the next 7 days';
    } else if(filter_value == 'next-30-days') {
      sub_string = 'for the next 30 days';
    } else if(filter_value == 'custom-dates') {
      sub_string = 'during ' + this.titleCase(document.querySelector('.js-custom-date-label').innerText);
    } else {
      sub_string = 'in the category ' + this.titleCase(filter_value);
    }
    this.temp_bar.innerHTML = '<p>Sweet! Events ' + sub_string + '.</p>';
    this.temp_bar.classList.add('--active');

    setTimeout(() => {
      this.temp_bar.classList.remove('--active');
      this.temp_bar.innerHTML = '';
    }, 2000);
  }

  updateFilterStatusBar() {
    // we are disabling for now
    return
    var return_message = '';
    var active_duration_label = document.querySelector('.js-filter-durations .js-listing-filter.--active .js-date-label');
    if(active_duration_label) {
      return_message += '<li>Events on ' + this.titleCase(active_duration_label.innerText) + '</li>';
    }

    var active_categories = document.querySelectorAll('.js-filter-categories .js-listing-filter.--active .js-category-label');
    if(active_categories) {
      var active_categories_label = "";
      active_categories.forEach((active_category) => {
        active_categories_label += active_category.innerText + ', ';
      });
      if(active_categories_label) {
        return_message += '<li>Events in ' + this.titleCase(active_categories_label.slice(0, -2)) + '</li>';
      }
    }

    if(return_message) {
      if(this.message_bar){
        this.message_bar.innerHTML = '<ul>' + return_message + '</ul>';
        this.message_bar.classList.add('--active');
      }
    } else {
      if(this.message_bar){
        this.message_bar.classList.remove('--active');
        this.message_bar.innerHTML = '';
      }
    }
  }

  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for(var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }
}
